import script from "./Tables.vue?vue&type=script&setup=true&lang=js"
export * from "./Tables.vue?vue&type=script&setup=true&lang=js"

import "./Tables.vue?vue&type=style&index=0&id=fec321ba&lang=less&scoped=true"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fec321ba"]])

export default __exports__